/**
 * External dependencies
 */
import React from 'react';
import { isString, toArray } from 'lodash';

/**
 * Internal dependencies
 */
import './styles.scss';
import LoggedInMeTopbar from 'layout/topbar/logged-in-me';
import MyReportsComponent from './my-reports/main';
import ReportLibraryComponent from './report-library/main';

// end of removed
// 
export const navigation = (context, next) => {
	context.topbar = <LoggedInMeTopbar path={context.path} />;
	next();
};

// everything above this line will be removed
//
export const myReports = (context, next) => {
	let query = context.query || {};

	let dataSetFilters = isString(query.dataSetFilters) ? [query.dataSetFilters] : toArray(query.dataSetFilters) || [];
	let dataTypeFilters = isString(query.dataTypeFilters)
		? [query.dataTypeFilters]
		: toArray(query.dataTypeFilters) || [];

	context.primary = <MyReportsComponent dataTypeFilters={dataTypeFilters} dataSetFilters={dataSetFilters} />;
	next();
};

export const reportLibrary = (context, next) => {
	let query = context.query || {};

	let dataSetFilters = isString(query.dataSetFilters) ? [query.dataSetFilters] : toArray(query.dataSetFilters) || [];
	let dataTypeFilters = isString(query.dataTypeFilters)
		? [query.dataTypeFilters]
		: toArray(query.dataTypeFilters) || [];

	context.primary = <ReportLibraryComponent dataTypeFilters={dataTypeFilters} dataSetFilters={dataSetFilters} />;
	next();
};
